import DataTable from "datatables.net-dt";
import React, { useEffect, useState } from "react";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import { useSelector } from "react-redux";
import Loader from "../../components/Loader";
import IndexSVA from "./IndexSVA";
import SwachhVidyalayaTabs from "./SwachhVidyalayaTabs";

const SwachhVidyalayaComponent = () => {
  const { languageType } = useSelector((state) => state.homeSlice);

  const {
    data: swachhVidyalayaData = [],
    isLoading: swachhVidyalayaIsloading,
  } = useGetProtectedApiDataQuery({ url: "swachhbharat", lang: languageType });

  const [activeTab, setActiveTab] = useState("index");
  useEffect(() => {
    if (swachhVidyalayaData.length > 0) {
      const lastElement = swachhVidyalayaData[swachhVidyalayaData.length - 1];
      // setActiveTab(lastElement.title);
      setActiveTab("index");
    }
  }, [swachhVidyalayaData, languageType]);

  useEffect(() => {
    const tableElement = document.getElementById("example");
    const table = new DataTable(tableElement, {
      info: false,
      ordering: true,
      paging: true,
    });
    return () => {
      table.destroy();
    };
  }, [activeTab]);

  if (swachhVidyalayaIsloading) {
    return <Loader />;
  }
  return (
    <>
      <div className="row mt-2">
        <div className="col-12 col-sm-12 col-md-3 col-lg-3 print-left">
          <div className="innleft_section">
            <ul className="menu nav nav-pills flex-column">
              <li className="nav-item">
                <a
                  href="#"
                  className={`nav-link ${
                    activeTab === "index" ? "active" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveTab("index");
                    //  setLastUpdated(extractDateFromStr(item.changed));
                  }}
                >
                  Index
                </a>
              </li>
              {swachhVidyalayaData
                .slice()
                .reverse()
                .map((item, index) => (
                  <li key={index} className="nav-item">
                    <a
                      href="#"
                      className={`nav-link ${
                        activeTab === item.title ? "active" : ""
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        setActiveTab(item.title);
                        //  setLastUpdated(extractDateFromStr(item.changed));
                      }}
                    >
                      {item.title}
                    </a>
                  </li>
                ))}
            </ul>
          </div>
        </div>

        <div
          className="col-12 col-sm-12 col-md-9 col-lg-9 print-right"
          key={activeTab}
        >
          {activeTab === "index" ? (
            <IndexSVA setActiveTab={setActiveTab} />
          ) : (
            swachhVidyalayaData
              .slice()
              .reverse()
              .map((item, index) =>
                activeTab === item.title ? (
                  <SwachhVidyalayaTabs
                    key={index}
                    data={item}
                    title={item.title}
                    activeTab={activeTab.split(" ").join("-")}
                  />
                ) : null,
              )
          )}
          {/* {swachhVidyalayaData
                  .slice()
                  .reverse()
                  .map((item, index) => {
                    if (activeTab === item.title) {
                      return (
                        <SwachhVidyalayaTabs
                          key={index}
                          data={item}
                          title={item.title}
                        />
                      );
                    } else if (activeTab === "index") {
                      return <IndexSVA />;
                    } else {
                      return <></>;
                    }
                  })} */}
        </div>
      </div>
    </>
  );
};

export default SwachhVidyalayaComponent;
